import React, {Component} from 'react';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import DatePicker from "react-datepicker";
import LostItemFunctions from '../LostItem/LostItemFunctions';
import axios from 'axios';
import auth0Client from '../Auth';
import {SERVER_URL}  from '../Constants';

var QRCode = require('qrcode.react');


class ParcelPayment extends Component {

    constructor(props){
        super(props);

        this.state = {

            parcelItems: this.props.parcelItems,
            total: this.calcTotal(this.props.parcelItems),
            count: this.props.parcelItems.length,
            pickupName:'',
            guestPickupDate:new Date(),
            displayPaymentRequest:false,
            guestEmail:'',
            guestText:'',
            displayQRandSend:false,
            parcelPayment:{},
    }
};
calcTotal = (items) => {
    let total = 0;
    if (items.length === 0) return total;
    items.forEach(parcelItem => {
        if (!Number.isNaN(parcelItem.serviceFee) && parcelItem.serviceFee >0){
            total += parcelItem.serviceFee;
        }
       
    });
    return total;

}

formatCurrency=(val)=>{
    if (!Number.isNaN(val) && val >0){
     return LostItemFunctions.formatMoney(val)
    }else{
        return LostItemFunctions.formatMoney(0)
    }
  }


  batchUpdateGuestReturn=()=>{

    // check if name and date are provided
    if (!this.state.pickupName  || !this.state.guestPickupDate){
        alert('Please provide the name and date');
        return;
    };


    this.setState({disabled:true});
    let ids = [];
    this.state.parcelItems.forEach(parcelItem => {
        ids.push(parcelItem.id);
    });
    
    
    axios.post(SERVER_URL +  '/SR/RunBatch',{
        ids:ids,
        statusCd:'GP',
        batchUpdatedNote:this.state.batchUpdatedNote,
        guestPickupDate:this.state.guestPickupDate,
        pickupName:this.state.pickupName
       }, 
       {
        headers: { 
          'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId': auth0Client.getActiveVenuedId() 
        }
      }).then((res)=>{
        
        if (res.status !== 200) {
            //place your reentry code
            console.log(res);
            alert('An error occured. ' + res.message);
         
         }else{
            
           this.setState({
                disabled:false, 
                displayPaymentRequest:true,
                
            });
            
           
         }
    
    
        // reload
         
    
        }).catch((e)=>{ 
            console.log(e);
            alert('An error occured. ' + e.message);
        });


  }

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }


  renderPaymentQRandSend=()=>{
        return(
            <div>
                <div className='row'>
                    <div className='col-11 text-center'>
                        <h5>Send the Payment Request to Guest</h5>
                        <small>Request payment from recipient through credit card transaction.</small>
                    </div>
                </div>
             
               
                <hr/>
                <br/>
                <br/>
                <div className='row'>
                    <div className='col-11 text-center'>
                    {(this.state.parcelPayment.paymentlinkUrl) &&   <QRCode renderAs="jpg" style={{width:'220px' ,height:'220px'}} value={this.state.parcelPayment.paymentlinkUrl} />
                    }
                    </div>
                </div>
                <br/>
                <div className='row'>
                    <div className='col-11 text-center'>
                     <b> url:</b>  <span className='text-info'><b><a target='_blank' rel="noopener noreferrer" href={this.state.parcelPayment.paymentlinkUrl}>{this.state.parcelPayment.paymentlinkUrl}</a></b></span>
                    <br/><br/> You can also send this link to the guest via email or text
                    </div>
                </div>

                <br/>
                <br/>
                <div className='row'>
                    <div className='col-8'>
                       
                        <input
                                        disabled={this.state.disabled}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        name="guestEmail"
                                        className="form-control"
                                        placeholder="enter email address"
                                        value= {this.state.guestEmail}
                                        />

                    </div>
                    <div className='col-4'>
                        <button style={{width:150}}  className="btn btn-success" title='Send' onClick={() => {this.sendEmail(this.state.guestEmail)}}>Send Email</button>
                    </div>
                </div>
                <br/> <br/>
                <div className='row'>
                    <div className='col-8'>
                     
                        <input
                                        disabled={true}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        name="guestText"
                                        className="form-control"
                                        placeholder="Not available yet"
                                        value= {this.state.guestText}
                                        />
                    </div>
                    <br/>
                    <br/>
                    <div className='col-4'>
                        <button disabled={true} style={{width:150}} className="btn btn-success" title='Send' onClick={() => {this.sendText(this.state.guestText)}}>Send Text</button>
                    </div>

                </div>
                <br/>
                <div className='row'>
                    <div className='col-11 text-center'>
                       <p className='text-primary'>Note: You can track and manage this payment request in the payments tab</p>
                    </div>
                </div>

            </div>
        )
  }

 
  createPaymentRequest=()=>{
    
            //this.setState({disabled:true});
            let ids = [];
            this.state.parcelItems.forEach(parcelItem => {
                ids.push(parcelItem.id);
            });
            axios.post(SERVER_URL +  '/SR/CreatePaymentRequest',{
                ids:ids,
                amount:this.state.total,
                note:this.state.batchUpdatedNote, //'new payment request for return to guest.',
                name:this.state.pickupName
               }, 
               {
                headers: { 
                  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                  'venueId': auth0Client.getActiveVenuedId() 
                }
              }).then((res)=>{
                
                if (res.status !== 200) {
                    //place your reentry code
                    console.log(res);
                    alert('An error occured. ' + res.message);
                 
                 }else{
                    console.log(res.data);
                   this.setState({
                    disabled:false, 
                    displayPaymentRequest:true,
                    displayQRandSend:true,
                    parcelPayment:res.data
                 });
                    
                   
                 }
            
            
                // reload
                 
            
                }).catch((e)=>{ 
                    console.log(e);
                    alert('An error occured. ' + e.message);
                });
          
    }

 returnDetails=()=>{
    return(
        <div >
                        <h5>Return To Recipient</h5>
                        <small>Each parcel will be assigned the following:</small>
                        <hr/>

                      

                        <div className='row'>
                            <div className='col-5'>
                            <label htmlFor="pickupName" className='text-danger'><b>Name (Bill To):</b></label>
                                    <input
                                        disabled={this.state.disabled}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        name="pickupName"
                                        className="form-control"
                                        placeholder="Person picking up the parcel(s)"
                                        value= {this.state.pickupName}
                                        />
                            </div>
                            <div className='col-5'>
                            <label htmlFor="returnToGuest" className='text-danger'><b>Date Returned To Guest:</b></label>
                                            <br/>
                                            <DatePicker
                                                className="form-control"
                                                onChange={this.onReturnedguestPickupDateChanged}
                                                name="guestPickupDate"
                                                selected={this.state.guestPickupDate}
                                            />      
                          

                              
                                        
                               </div>

                       
                        </div>
                        <div className='row'>
                            <div className='col-10 '>

                                <label htmlFor="batchUpdatedNote" className='text-primary'><b>Note:</b></label>
                                            <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="batchUpdatedNote"
                                                className="form-control"
                                                placeholder="optional"
                                                value= {this.state.batchUpdatedNote}
                                                />
                                        </div>

                            </div>
                            <br/>
                         
               
               


            </div>
    )
 }
  renderPaymentRequest=()=>{
    if (this.state.displayQRandSend){
        return this.renderPaymentQRandSend();
    }
    else {
        return(
            <div>
                <div className='row'>
                    <div className='col-11 text-center'>
                    <h3 className='text-success'>{this.state.count} Item(s) successfully returned</h3>
                    </div>
                </div>
                <br/>
                <h5>Payment Request</h5>
                <small>Request payment from recipient through credit card transaction.</small>
                <hr/>
                <br/>
                <div className='row'>
                    <div className='col-11 text-center'>
    
                <button
                    disabled={this.state.disabled}
                    className="btn btn-success"
                    onClick={() => {this.createPaymentRequest()}}>
                        Create a Payment Request Link Now
                  </button>
                     </div>
                  </div>
    
            </div>
        )
    }
   

  }

  renderSelectedParcels=()=>{
  
        return(
            <div> <h5>Selected Parcels:</h5>
            <div className='row'>
                <div className='col-11'>
                    <div style={{maxHeight:'400px', overflow:'auto', display:'inline-block', width:'780px'}}>
                        <table className='table-sm' style={{width:'100%'}}>
                        <thead>
                            <tr>
                                
                                <th>Parcel Name</th>
                                <th>Parcel Size / Weight</th>
                                <th>Parcel Price</th>
                            </tr>
                        </thead>
                        <tbody style={{overflowY:'scroll',display:'table-row-group',height:'350px'}}>
                            {this.state.parcelItems.map((parcelItem) => {
                                return (
                                    <tr key={parcelItem.id}>
                                       
                                        <td><small>{parcelItem.recipient}</small></td>
                                        <td><small>{parcelItem.parcelSize}</small></td>
                                        <td className='text-right'><small><b>{this.formatCurrency(parcelItem.serviceFee)}</b></small></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    </div>
                </div>
          </div> 
          <hr/>
                  <div className='row'>
                    <div className='col-11 text-right'>
                        <h5>Total: {this.formatCurrency(this.state.total)}</h5>
                        <small>Plus processing fee</small>
                    </div>
                  </div>
          
          </div>
        )



    }

    sendEmail=()=>{

        if(!this.state.guestEmail || this.state.guestEmail === ''){

            alert('Please provide an email address');
            return;
        };
        if (!this.state.parcelPayment.objectId || this.state.parcelPayment.objectId === ''){
            alert('An error occured. Please try again');
            return;
        }

        axios.post(SERVER_URL +  '/ParcelNotify/sendParcelRequest',{
            parcelPaymentId:this.state.parcelPayment.objectId,
            email:this.state.guestEmail,
           }, 
           {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId() 
            }
          }).then((res)=>{
            
            if (res.status !== 200) {
                //place your reentry code
                console.log(res);
                alert('An error occured. ' + res.message);
             
             }else{
                console.log(res.data);
               this.setState({
                disabled:false, 
                
                 });
                 alert('Email sent');
                
               
             }
        
        
            // reload
             
        
            }).catch((e)=>{ 
                console.log(e);
                alert('An error occured. ' + e.message);
            });

    }
    sendText=(text)=>{
            
        }


    render(){




            return (
                <div style={{width:'800px', height:'800px'}}>
                    { (!this.state.displayPaymentRequest) ? this.returnDetails() : null}
                    { (this.state.displayPaymentRequest) ? this.renderPaymentRequest() : this.renderSelectedParcels()}  
                    
            {!this.state.displayPaymentRequest && <div className='row'>

            <div className='col-12 text-center'>
              <button
                disabled={this.state.disabled}
                className="btn btn-success"
                onClick={() => {this.batchUpdateGuestReturn()}}>
                  Process {this.state.count} Parcels
              </button>
            </div>
          </div>
            }

            <br/>
                 
    </div>
            );
        }

}

export default ParcelPayment;